// ####################################################
// HANDLE MEDIA ERROR
// ####################################################

import { delay, getDataTimeString } from '@src/utils';

export const isHtml = (str: string) => {
  const a = document.createElement('div');
  a.innerHTML = str;
  for (let c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType === 1) return true;
  }
  return false;
};

export const createVideoElement = ({ videoUrl, stream }: { videoUrl?: string; stream?: MediaStream }) => {
  const video = document.createElement('video');
  if (videoUrl) video.src = videoUrl;
  if (stream) video.srcObject = stream;
  video.muted = true;
  video.autoplay = true;
  video.playsInline = true;

  return video;
};

export const createCanvasElement = ({ width = 1280, height = 720 }: { width?: number; height?: number }) => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  return canvas;
};

export const snapshotRoom = async () => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const video = document.createElement('video');

  try {
    const captureStream = await navigator.mediaDevices.getDisplayMedia({
      video: true,
    });

    video.srcObject = captureStream;
    video.onloadedmetadata = () => {
      video.style.width = `${video.videoWidth}px`;
      video.style.height = `${video.videoHeight}px`;
      video.play();
    };

    // Wait for the video to start playing
    video.onplay = async () => {
      // Sleep some ms
      await delay(1000);

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context?.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Create a link element to download the image
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = getDataTimeString() + '_snapshot.png';
      link.click();

      // Stop all video tracks to release the capture stream
      captureStream.getTracks().forEach((track) => track.stop());

      // Clean up: remove references to avoid memory leaks
      video.srcObject = null;
      canvas.width = 0;
      canvas.height = 0;
    };
  } catch (err) {
    console.error('Error: ' + err);
  }
};

export const toggleFullscreen = async () => {
  try {
    if (!document.fullscreenElement) {
      await document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  } catch (error) {
    console.error('Error during fullscreen toggle:', error);
    throw error;
  }
};
